/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepConstraintDto } from './StepConstraintDto';
import {
    StepConstraintDtoFromJSON,
    StepConstraintDtoFromJSONTyped,
    StepConstraintDtoToJSON,
    StepConstraintDtoToJSONTyped,
} from './StepConstraintDto';

/**
 * 
 * @export
 * @interface UpdateQuestionCommand
 */
export interface UpdateQuestionCommand {
    /**
     * Question type ID
     * @type {string}
     * @memberof UpdateQuestionCommand
     */
    questionTypeId: string;
    /**
     * Question key/code
     * @type {string}
     * @memberof UpdateQuestionCommand
     */
    key: string;
    /**
     * Question label/text
     * @type {string}
     * @memberof UpdateQuestionCommand
     */
    label: string;
    /**
     * Step number in the questionnaire
     * @type {number}
     * @memberof UpdateQuestionCommand
     */
    step?: number | null;
    /**
     * Display order of the question
     * @type {number}
     * @memberof UpdateQuestionCommand
     */
    displayOrder: number;
    /**
     * Icon key for the question
     * @type {string}
     * @memberof UpdateQuestionCommand
     */
    iconKey?: string | null;
    /**
     * Group title for question grouping
     * @type {string}
     * @memberof UpdateQuestionCommand
     */
    groupTitle?: string | null;
    /**
     * Whether the question is required
     * @type {boolean}
     * @memberof UpdateQuestionCommand
     */
    isRequired?: boolean;
    /**
     * Dependencies for this question
     * @type {Array<StepConstraintDto>}
     * @memberof UpdateQuestionCommand
     */
    dependsOn?: Array<StepConstraintDto> | null;
    /**
     * Constraints applied to this question
     * @type {Array<StepConstraintDto>}
     * @memberof UpdateQuestionCommand
     */
    constraints?: Array<StepConstraintDto> | null;
    /**
     * Conditions to skip this question
     * @type {Array<StepConstraintDto>}
     * @memberof UpdateQuestionCommand
     */
    skipIf?: Array<StepConstraintDto> | null;
}

/**
 * Check if a given object implements the UpdateQuestionCommand interface.
 */
export function instanceOfUpdateQuestionCommand(value: object): value is UpdateQuestionCommand {
    if (!('questionTypeId' in value) || value['questionTypeId'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    return true;
}

export function UpdateQuestionCommandFromJSON(json: any): UpdateQuestionCommand {
    return UpdateQuestionCommandFromJSONTyped(json, false);
}

export function UpdateQuestionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuestionCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'questionTypeId': json['questionTypeId'],
        'key': json['key'],
        'label': json['label'],
        'step': json['step'] == null ? undefined : json['step'],
        'displayOrder': json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'dependsOn': json['dependsOn'] == null ? undefined : ((json['dependsOn'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'constraints': json['constraints'] == null ? undefined : ((json['constraints'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'skipIf': json['skipIf'] == null ? undefined : ((json['skipIf'] as Array<any>).map(StepConstraintDtoFromJSON)),
    };
}

export function UpdateQuestionCommandToJSON(json: any): UpdateQuestionCommand {
    return UpdateQuestionCommandToJSONTyped(json, false);
}

export function UpdateQuestionCommandToJSONTyped(value?: UpdateQuestionCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionTypeId': value['questionTypeId'],
        'key': value['key'],
        'label': value['label'],
        'step': value['step'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'groupTitle': value['groupTitle'],
        'isRequired': value['isRequired'],
        'dependsOn': value['dependsOn'] == null ? undefined : ((value['dependsOn'] as Array<any>).map(StepConstraintDtoToJSON)),
        'constraints': value['constraints'] == null ? undefined : ((value['constraints'] as Array<any>).map(StepConstraintDtoToJSON)),
        'skipIf': value['skipIf'] == null ? undefined : ((value['skipIf'] as Array<any>).map(StepConstraintDtoToJSON)),
    };
}

